<app-screen-shell contentClass="guest-upgrade-shell" layout="public-entry" variant="guest" [showHeader]="false">
  <section class="guest-upgrade-card" data-testid="guest-upgrade-screen" aria-live="polite">
    <img class="guest-upgrade-logo" src="assets/images/footballer-zone-logo-transparent.png" alt="Footballer.zone">

    <div class="guest-upgrade-progress" aria-hidden="true">
      <span class="is-done">1</span><i></i><span [class.is-done]="state !== 'PREPARING'">2</span><i></i><span [class.is-done]="state === 'COMPLETED'">3</span>
    </div>

    @if (state === 'PREPARING') {
      <app-loading-state titleKey="guestUpgrade.flow.preparingTitle" subtitleKey="guestUpgrade.flow.preparingDescription" [compact]="true"></app-loading-state>
    }

    @if (state === 'READY' || state === 'AUTHENTICATING') {
      <div class="guest-upgrade-icon"><i class="fa fa-shield" aria-hidden="true"></i></div>
      <h1>{{ 'guestUpgrade.flow.readyTitle' | translate }}</h1>
      <p>{{ (isParticipantUpgrade() ? 'guestUpgrade.flow.readyDescriptionParticipant' : 'guestUpgrade.flow.readyDescription') | translate }}</p>
      <strong class="guest-upgrade-match">{{ eventName() }}</strong>
      <ul>
        <li>{{ (isParticipantUpgrade() ? 'guestUpgrade.flow.keepMatchParticipant' : 'guestUpgrade.flow.keepMatch') | translate }}</li>
        <li>{{ (isParticipantUpgrade() ? 'guestUpgrade.flow.keepRoleParticipant' : 'guestUpgrade.flow.keepRole') | translate }}</li>
        <li>{{ 'guestUpgrade.flow.returnAfterLogin' | translate }}</li>
      </ul>
      <button type="button" class="btn btn-outline-primary btn-block" data-testid="guest-upgrade-login" [disabled]="state === 'AUTHENTICATING'" (click)="login()">
        {{ 'auth.login' | translate }}
      </button>
      <button type="button" class="btn btn-primary btn-block" data-testid="guest-upgrade-create-account" [disabled]="state === 'AUTHENTICATING'" (click)="createAccount()">
        {{ 'guestUpgrade.flow.createAccount' | translate }}
      </button>
      @if (isMobileBrowser) {
        <button type="button" class="btn btn-link btn-block" data-testid="guest-upgrade-continue-in-app" (click)="continueInApp()" [disabled]="handoffLoading">
          {{ 'guestUpgrade.flow.continueInApp' | translate }}
        </button>
      }
      <button type="button" class="btn btn-link btn-block text-muted" (click)="returnToGuest()">{{ 'guestUpgrade.flow.notNow' | translate }}</button>
    }

    @if (state === 'COMPLETING') {
      <app-loading-state titleKey="guestUpgrade.flow.connectingTitle" [subtitleKey]="isParticipantUpgrade() ? 'guestUpgrade.flow.connectingDescriptionParticipant' : 'guestUpgrade.flow.connectingDescription'" [compact]="true"></app-loading-state>
    }

    @if (state === 'HANDED_OFF') {
      <div class="guest-upgrade-icon"><i class="fa fa-mobile" aria-hidden="true"></i></div>
      <h1>{{ 'guestUpgrade.flow.handedOffTitle' | translate }}</h1>
      <p>{{ 'guestUpgrade.flow.handedOffDescription' | translate }}</p>
      <strong class="guest-upgrade-match">{{ eventName() }}</strong>
      <button type="button" class="btn btn-primary btn-block" data-testid="guest-upgrade-check-app-status" (click)="retry()">
        {{ 'guestUpgrade.flow.checkAppStatus' | translate }}
      </button>
      <button type="button" class="btn btn-link btn-block" (click)="returnToGuest()">{{ 'guestUpgrade.flow.returnToGuest' | translate }}</button>
    }

    @if (state === 'COMPLETED') {
      <div class="guest-upgrade-icon is-success"><i class="fa fa-check" aria-hidden="true"></i></div>
      <h1>{{ 'guestUpgrade.flow.completedTitle' | translate }}</h1>
      <p>{{ (isParticipantUpgrade() ? 'guestUpgrade.flow.completedDescriptionParticipant' : 'guestUpgrade.flow.completedDescription') | translate }}</p>
      <strong class="guest-upgrade-match">{{ eventName() }}</strong>
      <button type="button" class="btn btn-primary btn-block" data-testid="guest-upgrade-open-match" (click)="openMatch()">{{ openMatchLabelKey() | translate }}</button>
    }

    @if (state === 'ERROR') {
      <div class="guest-upgrade-icon is-error"><i class="fa fa-exclamation" aria-hidden="true"></i></div>
      <h1>{{ 'guestUpgrade.flow.errorTitle' | translate }}</h1>
      <p>{{ errorMessageKey ? (errorMessageKey | translate) : errorMessage }}</p>
      <button type="button" class="btn btn-primary btn-block" data-testid="guest-upgrade-retry" (click)="retry()">
        {{ retryLabelKey() | translate }}
      </button>
      @if (retryLabelKey() !== 'guestUpgrade.flow.returnToGuest') {
        <button type="button" class="btn btn-link btn-block" (click)="returnToGuest()">{{ 'guestUpgrade.flow.returnToGuest' | translate }}</button>
      }
    }
  </section>
</app-screen-shell>
